var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('Title',{attrs:{"title_id":"imgTitle-page-shop","title_text":_vm.$t('page-title.shop.title'),"subtitle_text":_vm.$t('page-title.shop.subtitle')}}),_c('tShop'),_c('t-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }